module.exports = "/img/_/_/_/assets/images/creeper/battle/common//41.jpg?76b49edb7f7c5e4aa74eb289de823157";